module.exports = __webpack_public_path__ + "h5/img/boutiqueTitle.7a2331eb.png";